import React, { use, useState, useEffect, Suspense } from 'react';
import { Layout, Menu, Button, Popover, Popconfirm } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  SettingOutlined,
  DashboardOutlined,
  ShoppingOutlined,
  ShopOutlined,
  GiftOutlined,
  VideoCameraOutlined,
  PlaySquareOutlined,
  HeartOutlined
} from '@ant-design/icons';
import './index.css';
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from "react-router-dom";
import type { RootState, AppDispatch } from '../../store/index'
import { useNavigate, Outlet } from 'react-router-dom';
import { setUserState } from '../../store/user/userInfo'
import { setCurrentMenu } from '../../store/user/userMenu'
import { useCookie } from '@/utils/util'
import { menuFormatter } from '@/utils/routerForm';
import { getAllMenu } from "@/api/api-menu-list"
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DashboardIcon = DashboardOutlined;

const { Header, Sider, Content } = Layout;

// interface SystemLayoutProps {
//   children: React.ReactNode;
// }

const SystemLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const user = useSelector((state: RootState) => state.user)
  const [defaultOpenKeys, setDefaultOpenKeys] = useState(['taobao'])
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState('')
  const [menuItems, setMenuItems] = useState(menuFormatter())
  const dispatch = useDispatch<AppDispatch>()
  const isLoggedIn = useSelector((state: any) => {
    return !!state.user.accessToken
  });
  const location = useLocation();
  const { value: token, setValue: setToken, remove: removeToken } = useCookie('token');
  useEffect(() => {

    setMenuItems(menuFormatter())
    setDefaultSelectedKeys(menuItems[0].children[0].key)
    setDefaultOpenKeys([menuItems[0].key])
    return () => {
    };
  }, [isLoggedIn]);
  const navigate = useNavigate();
  useEffect(() => {
    setDefaultSelectedKeys(location.pathname)
    setDefaultOpenKeys([`/${location.pathname.split('/')[1]}`])
  }, [location.pathname]);
  const handleMenuAction = (openKeys: string[]) => {
    setDefaultOpenKeys(openKeys)


  }
  const isLogout = () => {
    navigate('/login')
    dispatch(setUserState({ accessToken: '', authorization: '', roleCode: '', username: '' }))
    dispatch(setCurrentMenu({ currentmenu: '' }))
    removeToken()
  }
  const content = (
    <div>

      <Popconfirm
        title="退出登录"
        description="确定退出登录吗?"
        okText="Yes"
        onConfirm={isLogout}
        cancelText="No"
      >
        <Button type='text' >退出登录</Button>
      </Popconfirm>
    </div>
  );
  const handleMenuClick = ({ key }: { key: string }) => {
    // 处理淘宝关键词PC列表跳转
    setDefaultSelectedKeys(key)
    navigate(key)

  };

  // const menuItems = [
  //   {
  //     key: 'tb',
  //     label: '淘宝',
  //     icon: <ShoppingOutlined />,
  //     children: [
  //       { key: '/tb/taobao-keyword', label: '关键词PC列表' },
  //       { key: '/tb/taobao-app-keyword', label: '关键词APP列表' },
  //       { key: '/tb/taobao-image', label: '图搜PC列表' },
  //       { key: '/tb/taobao-app-image', label: '图搜APP列表' },
  //     ],
  //   },
  //   {
  //     key: 'jd',
  //     label: '京东',
  //     icon: <ShopOutlined />,
  //     children: [
  //       { key: '/jd/jd-keyword', label: '关键词PC列表' },
  //       { key: '/jd/jd-app-keyword', label: '关键词APP列表' },
  //       { key: '/jd/jd-image', label: '图搜PC列表' },
  //       { key: '/jd/jd-app-image', label: '图搜APP列表' },

  //     ],
  //   },
  //   {
  //     key: 'pdd',
  //     label: '拼多多',
  //     icon: <GiftOutlined />,
  //     children: [
  //       { key: '/pdd/pdd-keyword', label: '关键词PC列表' },
  //       { key: '/pdd/pdd-app-keyword', label: '关键词APP列表' },
  //       { key: '/pdd/pdd-image', label: '图搜PC列表' },
  //       { key: '/pdd/pdd-app-image', label: '图搜APP列表' },

  //     ],
  //   },
  //   {
  //     key: 'douyin',
  //     label: '抖音',
  //     icon: <VideoCameraOutlined />,
  //     children: [
  //       { key: 'douyin-keyword', label: '关键词PC列表' },
  //       { key: 'douyin-app-keyword', label: '关键词APP列表' },
  //       { key: 'douyin-image', label: '图搜PC列表' },
  //       { key: 'douyin-app-image', label: '图搜APP列表' },
  //     ],
  //   },
  //   {
  //     key: 'kuaishou',
  //     label: '快手',
  //     icon: <PlaySquareOutlined />,
  //     children: [
  //       { key: 'kuaishou-keyword', label: '关键词PC列表' },
  //       { key: 'kuaishou-app-keyword', label: '关键词APP列表' },
  //       { key: 'kuaishou-image', label: '图搜PC列表' },
  //       { key: 'kuaishou-app-image', label: '图搜APP列表' },

  //     ],
  //   },
  //   {
  //     key: 'xiaohongshu',
  //     label: '小红书',
  //     icon: <HeartOutlined />,
  //     children: [
  //       { key: 'xiaohongshu-keyword', label: '关键词PC列表' },
  //       { key: 'xiaohongshu-app-keyword', label: '关键词APP列表' },
  //       { key: 'xiaohongshu-image', label: '图搜PC列表' },
  //       { key: 'xiaohongshu-app-image', label: '图搜APP列表' },

  //     ],
  //   },
  //   {
  //     key: 'users',
  //     icon: <UserOutlined />,
  //     label: '用户管理',
  //     children: [
  //       {
  //         key: 'users-list',
  //         label: '用户列表',
  //       },
  //       {
  //         key: 'roles-list',
  //         label: '角色管理',
  //       },

  //     ],
  //   },
  //   {
  //     key: 'setting',
  //     icon: <SettingOutlined />,
  //     label: '系统设置',
  //     children: [
  //       // {
  //       //   key: '3-1',
  //       //   label: '基本设置',
  //       // },
  //       {
  //         key: 'device-management',
  //         label: '设备管理',
  //       },
  //     ],
  //   },
  // ];

  return (
    <Layout className="system-layout">
      <Sider
        className="system-sider"
        trigger={null}
        collapsible
        collapsed={collapsed}
        theme="dark"
      >
        <div className="logo">
          {collapsed ? 'SA' : '系统管理'}
        </div>
        <div className="sider-menu">
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={[defaultSelectedKeys]}
            selectedKeys={[defaultSelectedKeys]}
            openKeys={defaultOpenKeys}

            items={menuItems}
            onClick={handleMenuClick}
            onOpenChange={handleMenuAction}
          />
        </div>
      </Sider>
      <Layout className="system-main">
        <Header className="system-header" style={{
          padding: 0,
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
          <div style={{ paddingRight: 16 }}>
            <Popover placement="leftTop" content={content} trigger="hover">

              <span>{user.username}</span>
            </Popover>
          </div>
        </Header>
        <Content
          className="system-content"
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: '#fff',
            borderRadius: 6,
          }}
        >
          <Suspense fallback={<div style={{ padding: 48, textAlign: 'center', color: '#999' }}>页面加载中...</div>}>
            <Outlet />
          </Suspense>
        </Content>
      </Layout>
    </Layout>
  );
};

export default SystemLayout;